import * as core from '../../../../../../../core'

import { query } from './details.query'

export const RESOURCE = {
  payload: {
    alias: 'details',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias:
                            'baseline-data-collection-framework.report-card',
                        },
                      },
                    },
                    span: 3,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'capacity-assessment-rubric.report-card',
                        },
                      },
                    },
                    span: 3,
                  },
                ],
              },
            },
            height: 800,
          },
        ],
      },
    },
    description: 'Details',
    name: 'details',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
